import { Entreprise } from '../../intervenant/models/entreprise.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class UniteCulturaleVigne {
    static jsonMap = {
        id: { key: 'id', optional: true },
        surfacePlantee: { key: 'surfacePlantee', optional: true },
        surfaceEngagee: { key: 'surfaceEngagee', optional: true },
        manquant: { key: 'manquant', optional: true },
        densite: { key: 'densite', optional: true },
        idProduitIdentifie: { key: 'idProduitIdentifie', optional: true },
        idProduitDestination: { key: 'idProduitDestination', optional: true },
        idEntrepriseDestination: { key: 'idEntrepriseDestination', optional: true },
        idModeConduite: { key: 'idModeConduite', optional: true },
        derogationTaille: { key: 'derogationTaille', optional: true },
        destinationVendange: { key: 'destinationVendange', optional: true, default: '' },
        produitIdentifie: { key: 'produitIdentifie', optional: true, default: '' },
        produitDestination: { key: 'produitDestination', optional: true, default: '' },
        entreprise: { key: 'entreprise', converter: new (ClassConverterFactory.build(Entreprise))(), optional: true }
    };

    id: number;
    surfacePlantee: number;
    surfaceEngagee: number;
    manquant: number;
    densite: number;
    idProduitIdentifie: number;
    idProduitDestination: number;
    idEntrepriseDestination: number;
    idModeConduite: number;
    derogationTaille: boolean;
    destinationVendange: string;
    produitIdentifie: string;
    produitDestination: string;
    entreprise: Entreprise;
}
